import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { getAccessTokenLoginByAccessTokenAzure, getSettingLogin } from 'api/authApi';
import AzureAuthentication from 'azure/azure-authentication-component';
import PillButton from 'components/atoms/Buttons/PillButton';
import useAuth from 'hooks/useAuth';
// import useQuery from 'hooks/useQuery';
import { useSnackbar } from 'notistack';
import React, { useLayoutEffect, useRef, useState } from 'react';
// import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getSessionStorage } from 'utility/browserStorageUtil';
import useStyles from './style';

const Copyright = () => (
  <Typography variant="subtitle2" color="textSecondary" align="center">
    ID/パスワードを忘れたときは社内システム管理者にご連絡ください。
  </Typography>
);

const Login: React.FC = () => {
  const [isSubmit, setSubmit] = useState(false);
  const history = useHistory();
  const { signin, signInBySSO } = useAuth();
  const classes = useStyles();
  const { companyCode: companyCodeParams } = useParams<{ companyCode: string }>();
  const ref = useRef<any>(null);
  // const dispatch = useDispatch();
  // const searchParams = useQuery();
  const { enqueueSnackbar } = useSnackbar();
  const [msalInstance, setMsalInstance] = useState<any>();
  const [useSSO, setUseSSO] = useState<number>();
  const [textScreen, setTextScreen] = useState<string>('');


  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = ref.current.elements;
    const id = form.ID.value;
    const password = form.password.value;

    // validate inputs
    if (!id || !password) {
      enqueueSnackbar('IDまたはパスワードが異なります', { variant: 'error' });
      return;
    }

    try {
      setSubmit(true);
      const companyCode = await signin(id, password);
      // redirect
      const expirationFlag = getSessionStorage('expirationFlag');
      const expirationDays = getSessionStorage('expirationDays');
      if (expirationFlag === '0') {
        const path = `/${companyCode}`;
        redirectURL(path);
      } else if (expirationFlag === '1' && expirationDays && expirationDays.length > 0 && Number(expirationDays) > -1) {
        const path = `/${companyCode}/comfirmChangePassword`;
        redirectURL(path);
      } else {
        const path = `/${companyCode}/changePassword`;
        redirectURL(path);
      }
    } catch (error: any) {
      if (error?.response?.status === 500) {
        enqueueSnackbar('Server error', { variant: 'error' });
        return;
      }
      // BE return 2 diff type of responses, zzz
      if (!error?.response) return;
      const errorResponse = error?.response?.data?.errors || error?.response?.data;
      if (errorResponse?.length && Array.isArray(errorResponse)) {
        errorResponse.forEach((err: any) => {
          enqueueSnackbar(err.defaultMessage ? err.defaultMessage : err.error, { variant: 'error' });
        });
      } else {
        enqueueSnackbar(error?.response?.data?.defaultMessage || error?.response?.error || error?.response?.data?.message || String(error?.response?.data || 'サーバー側でエラーが発生しました。'), { variant: 'error' });
      }
    } finally {
      setSubmit(false);
    }
  };

  const handleLoginAuthenticatedSSO = async (accessTokenAzure:string) => {
    try {
      setSubmit(true);
      const response = await getAccessTokenLoginByAccessTokenAzure(accessTokenAzure, companyCodeParams);
      const companyCode = await signInBySSO(response);
      // redirect
      enqueueSnackbar('ログイン出来ました。', { variant: 'success' });
      const path = `/${companyCode}`;
      redirectURL(path);
    } catch (error: any) {
      setSubmit(false);
      setTextScreen('シングルサインオンに失敗しました');
      if (error?.response?.status === 500) {
        enqueueSnackbar('Server error', { variant: 'error' });
        return;
      }
      // BE return 2 diff type of responses, zzz
      // if (!error?.response) return;
      // const errorResponse = error?.response?.data?.errors || error?.response?.data;
      // if (errorResponse?.length && Array.isArray(errorResponse)) {
      //   errorResponse.forEach((err: any) => {
      //     enqueueSnackbar(err.defaultMessage ? err.defaultMessage : err.error, { variant: 'error' });
      //   });
      // } else {
      //   enqueueSnackbar(error?.response?.data?.defaultMessage || error?.response?.error || error?.response?.data?.message || String(error?.response?.data || 'ログインに失敗しました'), { variant: 'error' });
      // }
    } finally {
      setSubmit(false);
    }
  };


  const redirectURL = (path: string = '/') => {
    history.push(path);
  };

  // const processUrlToken = async (accessToken: string) => {
  //   try {
  //     setLocalStorage('accessToken', accessToken);
  //     const staffId = getLocalStorage('staffId');
  //     const companyCode = getSessionStorage('companyCode');
  //     const path = `/${companyCode}`;
  //     await validateAccessTokenApi(companyCode, staffId);
  //     dispatch(setIsAuth(true));
  //     redirectDashboard(path);
  //   } catch (error) {
  //     removeLocalStorage('accessToken');
  //     throw error;
  //   }
  // };

  // useEffect(() => {
  //   // const accessToken = searchParams.get('accessToken');
  //   const accessToken = getLocalStorage('accessToken');
  //   if (accessToken) {
  //     processUrlToken(accessToken);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // eslint-disable-next-line @typescript-eslint/no-shadow


  useLayoutEffect(() => {
    getSettingLogin(companyCodeParams || '').then((res) => {
      setUseSSO(res.useSSO);
      if (res.useSSO === 1) {
        // setSubmit(true);
        const MSAL_CONFIG: Configuration = {
          auth: {
            clientId: res?.applicationID || '',
            authority: `https://login.microsoftonline.com/${res?.directoryID || ''}`,
          },
          cache: {
            cacheLocation: 'sessionStorage', // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
          },
          system: {},
        };
        const msalInstanceNew = new PublicClientApplication(MSAL_CONFIG);
        setMsalInstance(msalInstanceNew);
      }
    }).catch((error) => {
      const errorResponse = error?.response?.data?.errors || error?.response?.data;
      if (errorResponse?.length && Array.isArray(errorResponse)) {
        errorResponse.forEach((err: any) => {
          enqueueSnackbar(err.defaultMessage ? err.defaultMessage : err.error, { variant: 'error' });
        });
      } else {
        enqueueSnackbar(error?.response?.data?.defaultMessage || error?.response?.error || error?.response?.data?.message || String(error?.response?.data || 'ログインに失敗しました'), { variant: 'error' });
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyCodeParams]);


  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Typography component="h1" variant="h2" className={classes.title}>
          Win-Board
        </Typography>
        {useSSO === 0 && (
          <Box>
            <form ref={ref} className={classes.form} noValidate={true} onSubmit={submit}>
              <TextField
                variant="outlined"
                margin="normal"
            // required={true}
                fullWidth={true}
                id="id"
                label="ID"
                name="ID"
                autoComplete="ID"
                autoFocus={true}
              />
              <TextField
                variant="outlined"
                margin="normal"
            // required={true}
                fullWidth={true}
                name="password"
                label="パスワード"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <Box className={classes.submit}>
                <PillButton
                  variant="contained"
                  color="primary"
                  disabled={isSubmit}
                  type="submit"
                >
                  ログイン
                </PillButton>
              </Box>
            </form>
            <Box mt={2}>
              <Copyright />
            </Box>
          </Box>
        )}
        {useSSO === 1 && (
          <Box mt={2}>
            { msalInstance && (
            <MsalProvider instance={msalInstance}>
              <AzureAuthentication handleLoginAuthenticatedSSO={handleLoginAuthenticatedSSO} textScreen={textScreen} />
            </MsalProvider>
            )}
          </Box>
        )}
      </div>
    </Container>

  );
};
export default Login;
